import { Alert, Button, Form, Modal, Upload, message } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { InboxOutlined } from "@ant-design/icons";
import { appUiActions } from "../../../../config/actions/app/appUi.actions";
import donorsThunks from "../../../../config/thunks/businessDevAndPartnerships/donors/donors.thunks";

const { Dragger } = Upload;

const UploadProposalDocument = ({ donorId }) => {
  const dispatch = useDispatch();
  const visible = useSelector(
    (state) => state.AppUi.uploadProposalModal
  );
  const {
    uploadProposalDocumentLoading,
    uploadProposalDocumentSuccess,
    uploadProposalDocumentError,
    uploadProposalDocumentMessage,
  } = useSelector((state) => state.donorsState);

  const [form] = Form.useForm();

  const closeModal = () => {
    dispatch(appUiActions.toggleUploadProposalModal(false));
    form.resetFields();
  };

  const onFinish = (values) => {
    if (!values.proposal_document || !values.proposal_document.file) {
      message.error("Please select a proposal document to upload");
      return;
    }

    console.log(values.proposal_document.file);
    const formData = new FormData();
    formData.append(
      "proposal_document",
      values.proposal_document.file
    );

    dispatch(donorsThunks.uploadProposalDocument(donorId, formData));
  };

  useEffect(() => {
    if (uploadProposalDocumentSuccess && uploadProposalDocumentMessage) {
      message.success(uploadProposalDocumentMessage);
      closeModal();
    } else if (!uploadProposalDocumentSuccess && uploadProposalDocumentError) {
      message.error(uploadProposalDocumentError);
    }
  }, [
    uploadProposalDocumentSuccess,
    uploadProposalDocumentMessage,
    uploadProposalDocumentError,
  ]);

  return (
    <Modal
      title="UPLOAD PROPOSAL DOCUMENT"
      open={visible}
      footer={null}
      onCancel={closeModal}
      width={600}
    >
      {!uploadProposalDocumentSuccess && uploadProposalDocumentError && (
        <Alert
          showIcon
          message={uploadProposalDocumentError}
          className="my-2"
          type="error"
        />
      )}
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          name="proposal_document"
          rules={[
            { required: true, message: "Please upload a proposal document" },
          ]}
        >
          <Dragger
            name="proposal_document"
            maxCount={1}
            beforeUpload={() => false}
            accept=".pdf,.doc,.docx"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag proposal document to this area to upload
            </p>
            <p className="ant-upload-hint">
              Support for PDF, DOC, and DOCX files only
            </p>
          </Dragger>
        </Form.Item>
        <Form.Item>
          <Button
            loading={uploadProposalDocumentLoading}
            className="w-100"
            type="primary"
            htmlType="submit"
          >
            Upload Proposal Document
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UploadProposalDocument;

